import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from '@src/app/services/request.service';
import { MyProfile } from '@src/app/shared/types/address.type';

@Component({
    selector: 'app-auth-handler',
    templateUrl: './auth-handler.component.html',
    styleUrls: ['./auth-handler.component.less'],
})
export class AuthHandlerComponent implements OnInit {
    countdown = 3;

    constructor(private activatedRoute: ActivatedRoute, private requestService: RequestService) {}

    ngOnInit() {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        const socialMedia = window.localStorage.getItem('socialscan_social_media_type');

        if (socialMedia === 'twitter') {
            window.localStorage.setItem('socialscan_twitter_auth', JSON.stringify({ queryParams }));
        } else if (socialMedia === 'discord') {
            window.localStorage.setItem('socialscan_discord_auth', JSON.stringify({ queryParams }));
        }

        window.close();

        setTimeout(() => {
            if (socialMedia === 'twitter') {
                this.getUserInfoByTwitterParams(queryParams['code']).then(() => {
                    const backPage = localStorage.getItem('socialscan_back_page');
                    window.location.href = backPage;
                });
            }

            if (socialMedia === 'discord') {
                this.getUserInfoByDiscordParams(queryParams['code']).then(() => {
                    const backPage = localStorage.getItem('socialscan_back_page');
                    window.location.href = backPage;
                });
            }
        }, 1000);
    }

    getUserInfoByTwitterParams(code: string) {
        return this.requestService.sendRequest<MyProfile>({
            url: '/v1/socialscan/user/connect_twitter',
            method: 'POST',
            data: { code, redirect_url: this.getRedirectUrl('twitter') },
        });
    }

    getUserInfoByDiscordParams(code: string) {
        return this.requestService.sendRequest<MyProfile>({
            url: '/v1/socialscan/user/connect_discord',
            method: 'POST',
            data: { code, redirect_url: this.getRedirectUrl('discord') },
        });
    }

    getRedirectUrl(type: 'discord' | 'twitter') {
        return `${location.protocol}//${location.host}/public/completed-window/${type}`;
    }
}
